import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUserOrganization } from '@paragon/login-tools';

import { getActiveJobLayoutModel } from './jobContextSelectors';

/**
 * Usually we perform actions assuming the organization of the logged in user. There are some special cases, however,
 * where the organization we're interested in is different. An example of this is when an engineer from a third party
 * company is working on a repair job and creates a new component. The component should have the organization of the
 * repair job, not the organization of the third party engineer.
 */
export const getOrganizationForOpenContext = createSelector(
  getActiveJobLayoutModel,
  getLoggedInUserOrganization,

  (jobLayoutModel, loggedInUserOrganization) =>
    jobLayoutModel ? jobLayoutModel.ownerOrganization : loggedInUserOrganization!,
);
